import React from "react";
import { InputField } from "../AddPatientGroup.style";
import { useTranslation } from "hhn-commons";

type InputApartmentNumberProps = {
  patientInfoData: any;
  onFormDataChange: (key: string, value: string) => void;
};
const InputApartmentNumber = ({
  patientInfoData,
  onFormDataChange,
}: InputApartmentNumberProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  return (
    <InputField
      id="apartment-number"
      label={tNs("apartmentNumberLabel")}
      type="text"
      variant="standard"
      value={patientInfoData.address.apartmentNo ?? ""}
      onChange={e => {
        onFormDataChange("apartmentNo", e.target.value);
      }}
      slotProps={{
        inputLabel: { shrink: !!patientInfoData.address?.apartmentNo },
        htmlInput: {
          "data-testid": "apartment-no",
        },
      }}
    />
  );
};

export default InputApartmentNumber;
